import { render, staticRenderFns } from "./sksp.vue?vue&type=template&id=49396f8f&scoped=true&"
import script from "./sksp.vue?vue&type=script&lang=js&"
export * from "./sksp.vue?vue&type=script&lang=js&"
import style0 from "./sksp.vue?vue&type=style&index=0&id=49396f8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49396f8f",
  null
  
)

export default component.exports